import { EventEmitter, Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProcessListService {

  processList: Array<any>;
  processListEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private http: HttpService
  ) { }

  getById(processListId) {

    return this.http.get('process_list:get_by_id', { id: processListId })
      .pipe(
        map((result: any) => {
          if (result.type == 'OK')
            return result.data;
        })
      );

  }

  loadCandidates(processListId) {

    this.http.get('process_list:lead', { processList: processListId })
      .subscribe(
        (result: any) => {
          const { data } = result;
          localStorage.setItem(`candidates:${processListId}`, JSON.stringify(data));
        }
      )

  }

  getEvent() {
    return this.processListEvent;
  }

  add(candidate, processListId) {

    const candidatesToAddData = localStorage.getItem(`candidateList:${processListId}`);
    const candidatesData = localStorage.getItem(`candidates:${processListId}`);
    const candidatesToAdd: Array<any> = candidatesToAddData ? JSON.parse(candidatesToAddData) : [];
    const candidates: Array<any> = candidatesData ? JSON.parse(candidatesData) : [];

    if (
      candidatesToAdd.findIndex(item => item.id == candidate.id) > -1
      || candidates.findIndex(item => item.id == candidate.id) > -1
    )
      return false;

    const auxCandidate = { ...candidate };
    delete auxCandidate.tooltip$;

    // // Adiciona o array de keywords se passado
    // if (keywords) {
    //   auxCandidate.keywords = keywords;
    // }

    candidatesToAdd.push(auxCandidate);
    localStorage.setItem(`candidateList:${processListId}`, JSON.stringify(candidatesToAdd));
    this.processListEvent.emit();
    return true;

  }

  rejectedsLength(processListId: any) {

    const candidatesToRejectData = localStorage.getItem(`candidatesRejected:${processListId}`);
    const candidatesToReject = candidatesToRejectData ? JSON.parse(candidatesToRejectData) : [];

    return candidatesToReject.length;

  }

  clearRejectCandidates(processListId: any) {

    localStorage.removeItem(`candidatesRejected:${processListId}`);
    this.processListEvent.emit();

  }

  /**
   *rejeita ou remove da lista de rejeição os candidatos 
   */
  reject(candidateId: string, processListId: any) {

    const candidatesToRejectData = localStorage.getItem(`candidatesRejected:${processListId}`);
    const candidatesToReject = candidatesToRejectData ? JSON.parse(candidatesToRejectData) : [];
    const hasCandidate = candidatesToReject.includes(candidateId);

    if (hasCandidate) {
      const index = candidatesToReject.findIndex(_candidateId => _candidateId == candidateId);
      candidatesToReject.splice(index, 1);
    } else
      candidatesToReject.push(candidateId);

    localStorage.setItem(`candidatesRejected:${processListId}`, JSON.stringify(candidatesToReject));
    this.processListEvent.emit();

    return !hasCandidate;

  }

  hasCandidateRejected(candidateId: string, processListId: any) {

    const candidatesToRejectData = localStorage.getItem(`candidatesRejected:${processListId}`);
    const candidatesToReject = candidatesToRejectData ? JSON.parse(candidatesToRejectData) : [];

    return candidatesToReject.includes(candidateId);

  }

  clearCandidateToAdd(processListId) {

    localStorage.removeItem(`candidateList:${processListId}`);
    this.processListEvent.emit();

  }

  clear(processListId) {
    localStorage.removeItem(`candidateList:${processListId}`);
    localStorage.removeItem(`candidates:${processListId}`);
    this.processListEvent.emit();
  }

  remove(i: number, processListId) {

    const listData = localStorage.getItem(`candidateList:${processListId}`);
    if (!listData) return null;

    const list: Array<any> = JSON.parse(listData);
    list.splice(i, 1);
    localStorage.setItem(`candidateList:${processListId}`, JSON.stringify(list));
    this.processListEvent.emit();

  }

  removeFrom(lead: any, processListId: any) {

    const listData = localStorage.getItem(`candidates:${processListId}`)

    if (!listData) return null;

    const list: Array<any> = JSON.parse(listData);
    const index = list.findIndex(item => item.id == lead.id);

    if (index > -1) {
      list.splice(index, 1);
      localStorage.setItem(`candidates:${processListId}`, JSON.stringify(list));
      // this.processListEvent.emit();
    }


  }

  hasCandidateAlreadySelected(candidateId: number, processListId: any) {

    const candidatesData = localStorage.getItem(`candidates:${processListId}`);
    const candidates: Array<any> = candidatesData ? JSON.parse(candidatesData) : [];
    // console.log(candidates)
    return candidates.findIndex(item => item.id == candidateId) > -1;

  }

  hasCandidateSelected(candidateId, processListId) {

    const candidatesToAddData = localStorage.getItem(`candidateList:${processListId}`);
    const candidatesData = localStorage.getItem(`candidates:${processListId}`);
    const candidatesToAdd: Array<any> = candidatesToAddData ? JSON.parse(candidatesToAddData) : [];
    const candidates: Array<any> = candidatesData ? JSON.parse(candidatesData) : [];

    return candidatesToAdd.findIndex(item => item.id == candidateId) > -1
      || candidates.findIndex(item => item.id == candidateId) > -1

  }

  get(processListId) {

    const listData = localStorage.getItem(`candidateList:${processListId}`);
    if (!listData) return [];

    const list: Array<any> = JSON.parse(listData);
    return list;

  }

}
